import { render, staticRenderFns } from "./CargoCreate.vue?vue&type=template&id=5d62dba5&"
import script from "./CargoCreate.vue?vue&type=script&lang=js&"
export * from "./CargoCreate.vue?vue&type=script&lang=js&"
import style0 from "./CargoCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports